<template>
  <IconLucideEarth />
</template>
